import {
  Button,
  CircularProgress,
  IconButton,
  Radio,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import AllowAccess from "../Atoms/AllowAccess/AllowAccess";
import "./SingleUser.css";
import firebase from "firebase";
import { Delete } from "@material-ui/icons";
import CustomModal from "../Atoms/modal/CustomModal";
import { useHistory } from "react-router";

const getDate = (t) => {
  if (!t) {
    return undefined;
  }
  // console.log(t.getMonth().toString().length);
  let time = "";
  time = t.getFullYear() + "-";
  time +=
    (t.getMonth() + 1).toString().length === 1
      ? "0" + (t.getMonth() + 1) + "-"
      : t.getMonth() + 1 + "-";
  time += t.getDate().toString().length === 1 ? "0" + t.getDate() : t.getDate();

  // console.log(t.toISOString().substr(0, 10));
  // console.log(time);
  return time;
};

function SingleUser(props) {
  // console.log(props.match.params.id);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [authID, setAuthID] = useState(""); //
  const [isAuth, setIsAuth] = useState(""); //
  const [profileURL, setProfileURL] = useState(
    "https://media.istockphoto.com/vectors/user-avatar-profile-icon-black-vector-illustration-vector-id1209654046?k=6&m=1209654046&s=612x612&w=0&h=sNiHvwJm5SPrpTCjz-7eqSDqew5-f2hASM2FrGLtMJ4="
  );
  const [DOB, setDOB] = useState(""); //x
  const [DOM, setDOM] = useState(""); //x
  const [fatherName, setFatherName] = useState(""); //x
  const [firstname, setFirstname] = useState(""); //x
  const [middleName, setMiddleName] = useState(""); //x
  const [lastName, setLastName] = useState(""); //x
  const [email, setEmail] = useState(""); //x
  const [phoneNumber, setPhoneNumber] = useState(""); //x
  const [altPhoneNumber, setAltPhoneNumber] = useState(""); //x
  const [address, setAddress] = useState(""); //x
  const [gender, setGender] = useState(-1); //x
  const [isMarried, setIsMarried] = useState(false); //x
  const [addressProofBack, setAddressProofBack] = useState(""); //
  const [addressProofFront, setAddressProofFront] = useState(""); //
  const [bloodGroup, setBloodGroup] = useState(""); //x
  const [token, setToken] = useState("");

  const [submitVisible, setSubmitVisible] = useState(false);
  const [modal, setModal] = useState(false);
  const [deleteUser, setDeleteUser] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [expirationDate, setExpirationDate] = useState("");

  /*
authID X
address X
add proof front x
add proof back x
phone x
alt phone x
bloodgrp x
DOB x
DOM x
email x
fatherName x
firstName x
midddleName x
lastName x
gender x
isAuth    x
isMarried x
profileURL x
*/
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const userData = await db
        .collection("Users")
        .doc(props.match.params.id)
        .get();
      setAuthID(userData.data().authID);
      setIsAuth(userData.data().isAuthenticated);
      setProfileURL((p) =>
        userData.data().profilePhotoURL ? userData.data().profilePhotoURL : p
      );
      setDOB(getDate(userData.data().dateOfBirth.toDate()));
      setDOM(getDate(userData.data().dateOfMarriage?.toDate()));
      setFatherName(userData.data().fatherName);
      setFirstname(userData.data().firstName);
      setMiddleName(userData.data().middleName);
      setLastName(userData.data().lastName);
      setEmail(userData.data().emailAddress);
      setPhoneNumber(userData.data().phoneNumber);
      setAltPhoneNumber(userData.data().whatsAppNumber);
      setIsMarried(userData.data().isMarried);
      setAddress(userData.data().address);
      setAddressProofBack(userData.data().addressProofBack);
      setAddressProofFront(userData.data().addressProofFront);
      setGender(userData.data().gender);
      setBloodGroup(userData.data().bloodGroup);
      setToken(userData.data().token);
      setIsExpired(userData.data().isExpired);
      setExpirationDate(getDate(userData.data().expirationDate?.toDate()));
      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (firstname && fatherName && phoneNumber && address) {
      setSubmitVisible(true);
    } else {
      setSubmitVisible(false);
    }
  }, [firstname, fatherName, phoneNumber, address]);

  useEffect(() => {
    if (deleteUser) {
      const func = async () => {
        try {
          await db.collection("Users").doc(authID).delete();
          history.push("/UserData", { approve: false });
        } catch (e) {
          console.log(e);
        }
        setDeleteUser(false);
      };
      func();
    }

    //eslint-disable-next-line
  }, [deleteUser, authID]);

  const submitHandler = async () => {
    setLoading(true);
    // console.log(`${new Date(DOB).getDate()}-${new Date(DOB).getMonth() + 1}`);

    try {
      await db
        .collection("Users")
        .doc(authID)
        .update({
          fatherName:
            !fatherName || fatherName.length === 0 ? null : fatherName,
          firstName: !firstname || firstname.length === 0 ? null : firstname,
          middleName:
            !middleName || middleName.length === 0 ? null : middleName,
          lastName: !lastName || lastName.length === 0 ? null : lastName,
          gender,
          isMarried,
          emailAddress: !email || email.length === 0 ? null : email,
          phoneNumber:
            !phoneNumber || phoneNumber.length === 0 ? null : phoneNumber,
          whatsAppNumber:
            !altPhoneNumber || altPhoneNumber.length === 0
              ? null
              : altPhoneNumber,
          address: !address || address.length === 0 ? null : address,
          bloodGroup:
            !bloodGroup || bloodGroup.length === 0 ? null : bloodGroup,
          dateOfBirth: firebase.firestore.Timestamp.fromDate(new Date(DOB)),
          dateOfMarriage: isMarried
            ? firebase.firestore.Timestamp.fromDate(new Date(DOM))
            : null,
          isExpired,
          expirationDate: isExpired
            ? firebase.firestore.Timestamp.fromDate(new Date(expirationDate))
            : null,
          shortDOB: DOB
            ? `${new Date(DOB).getDate()}-${new Date(DOB).getMonth() + 1}`
            : null,
          shortED: isExpired
            ? `${new Date(expirationDate).getDate()}-${
                new Date(expirationDate).getMonth() + 1
              }`
            : null,
        });
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <CircularProgress
          style={{
            width: "100px",
            height: "100px",
            position: "fixed",
            left: "45vw",
            top: "40vh",
          }}
        />
      ) : (
        <div className="singleUser" style={{ marginBottom: "50px" }}>
          <div className="singleUser__imageContainer">
            <img className="singleUser__image" src={profileURL} alt="" />
          </div>
          <i style={{ color: "red" }}>
            Submit Button will appear only after you filled up all the required
            fields
          </i>
          <div className="singleUser__info">
            <div className="singleUser__head">
              <AllowAccess
                auth={isAuth}
                name={firstname}
                authID={authID}
                token={token}
              />
              <IconButton onClick={() => setModal(true)}>
                <Delete />
              </IconButton>

              <CustomModal
                modalState={[modal, setModal]}
                message={`Do you really want to DELETE user ${firstname}`}
                choiceState={[deleteUser, setDeleteUser]}
              />
            </div>

            <div>
              <CustomInput
                title="First Name"
                fieldState={[firstname, setFirstname]}
                required
              />
              <CustomInput
                title="Middle Name"
                fieldState={[middleName, setMiddleName]}
              />
              <CustomInput
                title="Last Name"
                fieldState={[lastName, setLastName]}
              />
            </div>
            <div>
              <CustomInput
                title="Blood Group"
                fieldState={[bloodGroup, setBloodGroup]}
              />
              <CustomInput
                title="Father's Name"
                fieldState={[fatherName, setFatherName]}
                required
              />
              <CustomInput title="Email" fieldState={[email, setEmail]} />
            </div>
            <div>
              <CustomInput
                title="Phone"
                fieldState={[phoneNumber, setPhoneNumber]}
                required
              />
              <CustomInput
                title="whatsApp Number"
                fieldState={[altPhoneNumber, setAltPhoneNumber]}
              />
            </div>
            <CustomInput
              title="Address"
              fieldState={[address, setAddress]}
              required
            />

            <div
              style={{
                flexDirection: "column",
                textAlign: "left",
              }}
            >
              <label>
                <b>Gender:</b>
                <label>
                  <Radio checked={gender === 0} onChange={() => setGender(0)} />
                  Male
                </label>
                <label>
                  <Radio checked={gender === 1} onChange={() => setGender(1)} />
                  Female
                </label>
              </label>
              <label>
                <b>Date of Birth:</b>
                <input
                  type="date"
                  value={DOB}
                  style={{ fontFamily: "sans-serif" }}
                  onChange={(e) => setDOB(e.target.value)}
                />
              </label>

              <label>
                <b>Expired:</b>
                <label>
                  <Radio
                    checked={isExpired}
                    onChange={() => setIsExpired(true)}
                  />
                  Yes
                </label>
                <label>
                  <Radio
                    checked={!isExpired}
                    onChange={() => setIsExpired(false)}
                  />
                  No
                </label>
              </label>
              {isExpired && (
                <label style={{ display: "flex", alignItems: "center" }}>
                  <b style={{ color: "red" }}>Date of Demise: </b>
                  <input
                    type="date"
                    value={expirationDate}
                    style={{ fontFamily: "sans-serif" }}
                    onChange={(e) => setExpirationDate(e.target.value)}
                  />
                </label>
              )}
            </div>

            <div
              style={{
                flexDirection: "column",
                textAlign: "left",
              }}
            >
              <label>
                <b>Married:</b>
                <label>
                  <Radio
                    checked={isMarried}
                    onChange={() => setIsMarried(true)}
                  />
                  Yes
                </label>
                <label>
                  <Radio
                    checked={!isMarried}
                    onChange={() => {
                      setIsMarried(false);
                      // setDOM(null);
                    }}
                  />
                  No
                </label>
              </label>
              {isMarried && (
                <label>
                  <b>Date of Marriage: </b>
                  <input
                    type="date"
                    value={DOM}
                    style={{ fontFamily: "sans-serif" }}
                    onChange={(e) => setDOM(e.target.value)}
                  />
                </label>
              )}
            </div>
            <b style={{ textAlign: "left", margin: "10px 0" }}>Address Proof</b>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "10px",
                // alignItems: "center",
              }}
            >
              <div
                className="singleUser__proof"
                onClick={() => window.open(addressProofFront, "_blank")}
              >
                <img
                  className="singleUser__proofImage"
                  src={addressProofFront}
                  alt=""
                />
                <p>Address Proof (Front)</p>
              </div>
              <div className="singleUser__proof">
                <img
                  className="singleUser__proofImage"
                  onClick={() => window.open(addressProofBack, "_blank")}
                  src={addressProofBack}
                  alt=""
                />
                <p>Address Proof (Back)</p>
              </div>
            </div>
          </div>

          <Button
            variant="contained"
            color="primary"
            style={{ margin: "20px 0" }}
            onClick={submitHandler}
            disabled={!submitVisible}
          >
            Submit
          </Button>
        </div>
      )}
    </>
  );
}

const CustomInput = ({ title, fieldState, required }) => {
  const [state, setstate] = fieldState;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flex: "1",
        margin: "5px 3px",
      }}
    >
      <TextField
        required={required}
        error={required && !state}
        value={state ? state : ""}
        label={title}
        style={{ width: "100%" }}
        onChange={(e) => setstate(e.target.value)}
      />
    </div>
  );
};

export default SingleUser;
